import { gql } from "@apollo/client";

const UPDATE_HONORARIO = gql`
    mutation updateHonorarioProfesional($input: AddHonorarioInput!, $idHonorarioProfesional: Int!){
        updateHonorarioProfesional(input: $input, idHonorarioProfesional: $idHonorarioProfesional) {
            success,
            error,
            valorEsperado
        }
    }
`;

export default UPDATE_HONORARIO;

export const adaptUpdateHonorarioInput = (data) => {
  const {
    usuario,
    productos,
    tecnologiasMedicas,
    ...restData
  } = data;
  return {
    ...restData,
    productos: null,
    tecnologiasMedicas: null,
    tipoReclamo: 2
  };
};